module.exports = __webpack_public_path__ + "static/media/key.87ac403b.svg";